import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import { Batch } from '../../batches/batch.interface';
import { CommuterTrafficFee } from '../../commuter-traffic-fees/commuter-traffic-fee.interface';

export class CommuterTrafficFeeService {
   async getCommuterTrafficFees(companyId: number, query: LocationQuery) {
      const response = await http.get(`/companies/${companyId}/commuter-traffic-fees`, { params: { ...query } });
      return response.data;
   }
   async getCommuterTrafficFee(companyId: number, commuterTrafficFeeId: number) {
      const response = await http.get<CommuterTrafficFee>(`/companies/${companyId}/commuter-traffic-fees/${commuterTrafficFeeId}`);
      return response.data;
   }
   async postCommuterTrafficFee(companyId: number, commuterTrafficFee: CommuterTrafficFee) {
      const response = await http.post<CommuterTrafficFee>(`/companies/${companyId}/commuter-traffic-fees`, commuterTrafficFee);
      return response.data;
   }
   async putCommuterTrafficFee(companyId: number, commuterTrafficFeeId: number, commuterTrafficFee: CommuterTrafficFee) {
      const response = await http.put<CommuterTrafficFee>(
         `/companies/${companyId}/commuter-traffic-fees/${commuterTrafficFeeId}`,
         commuterTrafficFee,
      );
      return response.data;
   }
   async deleteCommuterTrafficFee(companyId: number, commuterTrafficFeeId: number) {
      return await http.delete<CommuterTrafficFee>(`/companies/${companyId}/commuter-traffic-fees/${commuterTrafficFeeId}`);
   }
   async importCommuterTrafficFeeBatches(companyId: number, importFile: File) {
      const formData = new FormData();
      formData.append('import_file', importFile);
      return await http.post(`/companies/${companyId}/import-commuter-traffic-fee-batches`, formData);
   }
   async indexCommuterTrafficFees(companyId: number) {
      const response = await http.post<Batch>(`/companies/${companyId}/auto-index-contract-commuter-traffic-batches`);
      return response.data;
   }
}
